/**
 * exitTrail — the last few things that happened before someone left the test,
 * for "Why it stopped" in the admin dashboard (see exitDiagnostics.ts).
 *
 * Kept free of imports so any page or service can add a line without pulling
 * the camera code into its bundle. Lines are short descriptions such as
 * "Page /ran-test" or "Microphone: denied"; never answers, names or gaze data.
 */

const MAX_LINES = 20;
const MAX_CHARS = 80;

const loadedAt = Date.now();
let lines: string[] = [];
let lastText = '';

function stamp(): string {
  const s = Math.max(0, Math.round((Date.now() - loadedAt) / 1000));
  return s < 60 ? `${s}s` : `${Math.floor(s / 60)}m${String(s % 60).padStart(2, '0')}s`;
}

/** Adds one line, prefixed with the time since the page loaded; keeps the last 20. */
export function noteEvent(text: string): void {
  if (text === lastText) return; // the same event again adds nothing
  lastText = text;
  lines = [...lines, `${stamp()} ${text}`.slice(0, MAX_CHARS)].slice(-MAX_LINES);
}

export function getTrail(): string[] {
  return [...lines];
}

/** Test helper. */
export function resetTrailForTest(): void {
  lines = [];
  lastText = '';
}
